import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  ApiError,
  OrganizationPublicResponse,
  OrganizationWebPagePublicResponse,
  OrganizationsService,
  WebPageService,
} from "client/openapi";
import { LoadingBlock } from "components/StatusBlock";
import PublicOrgPage from "components/PublicBooking/PublicOrgPage";
import { PublicMessage } from "components/PublicBooking/PublicShell";
import { PageStatus } from "types";

/**
 * /organizations/:id, or "/" on an org's own domain; with /classes, the
 * Classes tab.
 */
function OrganizationWebPage({
  tab = "tutors",
}: {
  tab?: "tutors" | "classes";
}) {
  const { id } = useParams<{ id?: string }>();
  const [page, setPage] = useState<OrganizationWebPagePublicResponse>();
  const [org, setOrg] = useState<OrganizationPublicResponse>();
  const [failed, setFailed] = useState<number>();

  useEffect(() => {
    const loadPage = id
      ? WebPageService.getOrganizationWebPage({ orgId: Number(id) })
      : WebPageService.getOrganizationWebPageByCustomDomain();
    loadPage
      .then((loaded) => {
        setPage(loaded);
        return OrganizationsService.getOrganizationForWebPage({
          orgId: loaded.org_id,
        });
      })
      .then(setOrg)
      .catch((e: ApiError) => setFailed(e.status ?? 500));
  }, [id]);

  if (failed === 404)
    return <PublicMessage title="Online booking is closed." />;
  if (failed)
    return (
      <PublicMessage title="This page didn't load.">
        Check your connection and try again.
      </PublicMessage>
    );
  if (!page || !org) return <LoadingBlock status={PageStatus.LOADING} />;

  return (
    <>
      <Helmet>
        <title>{org.name}</title>
      </Helmet>
      <PublicOrgPage page={page} org={org} tab={tab} />
    </>
  );
}

export default OrganizationWebPage;
